import React, { useEffect, useState } from 'react';
import './Home.css';
import HeroSection from '../components/HeroSection';
import BannerSection from '../components/BannerSection';
import HeroSection2 from '../components/HeroSection2';
import Footer from '../components/Footer';
import HeroSlider from '../components/Testimonials';
import { useNavigate } from 'react-router-dom';
import Gallery from './Gallery';
import MenuComponent from '../components/PopularDishes';
import freeDrinkimage from './unnamed.jpg';
import { Modal, Button } from 'react-bootstrap';

const HomePage = ({ restaurant }) => {
  const navigate = useNavigate();
  const [modal, setShowModal] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const loadGoogleMaps = () => {
      if (window.google && window.google.maps) {
        initializeMap();
      } else {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBVBmPNmWThlFAv8lyHtESSsZIQLHiDl30`;
        script.async = true;
        script.defer = true;
        script.onload = () => initializeMap();
        document.body.appendChild(script);
      }
    };

    const initializeMap = () => {
      const mapOptions = {
        center: new window.google.maps.LatLng(34.0359971, -83.956007),
        zoom: 16,
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      };

      const map = new window.google.maps.Map(document.getElementById("gmp-map"), mapOptions);

      new window.google.maps.Marker({
        position: new window.google.maps.LatLng(34.0359971, -83.956007),
        title: "Lins Bistro",
        map: map,
      });
    };

    loadGoogleMaps();
  }, []);

  return (
    <div style={{ backgroundColor: 'white', marginTop: '80px' }}>
      {/* MODAL */}
      {/* <Modal
  show={modal}
  onHide={() => setShowModal(false)}
  centered
  backdrop="true" // enable clicking outside to close
  keyboard={true} // allow ESC key to close
>
  <Modal.Body className="p-0 position-relative">
    <img
      src={freeDrinkimage}
      alt="Promotion"
      style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '10px' }}
    />
    <Button
      style={{
        position: 'absolute',
        bottom: '2px',
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '10px 30px',
        fontSize: '16px',
        backgroundColor:'green'
      }}
      onClick={() => {
        setShowModal(false);
        navigate('/order');
      }}
    >
      Order Now
    </Button>
  </Modal.Body>
</Modal> */}
<Modal
  show={modal}
  onHide={() => setShowModal(false)}
  centered
  backdrop="true"
  keyboard={true}
>
  <Modal.Body className="p-4 text-center">
    <h5 className="fw-bold mb-3" style={{ color: '#d9534f' }}>
      📞 Temporary Phone Line Update
    </h5>
    <p className="mb-4" style={{ fontSize: '1rem', lineHeight: '1.5' }}>
      Our old phone line is currently out of service.  
      Please call us at{' '}
      <a
        href="tel:7703388978"
        style={{
          color: '#0d6efd',
          fontWeight: 'bold',
          textDecoration: 'none'
        }}
      >
        (770) 338-8978
      </a>{' '}
      for the next few days. Thank you!
    </p>
    <Button
      variant="primary"
      size="lg"
      className="w-100"
      style={{ maxWidth: '250px' }}
      onClick={() => setShowModal(false)}
    >
      Got it
    </Button>
  </Modal.Body>
</Modal>


      {/* PAGE CONTENT */}
      <HeroSlider />
      <BannerSection />
      <HeroSection2 />
      <Gallery />
      <HeroSection />
      <div className='gmp-map-1' id='gmp-map'></div>
      <MenuComponent />
      <Footer />
    </div>
  );
};

export default HomePage;
